export default __webpack_public_path__ + "static/media/converse.91da8804.mp4";